import i18next from "i18next";
import { useTranslation } from "react-i18next";
import { Navbar } from "../../Components/Navbar/Navbar";
import { Meta } from "../../Components/Helpers/Meta";
import { useParams } from "react-router-dom";
import InvestorSidebar from "../../Components/InvestorSidebar/InvestorSidebar";
import { LuDownload } from "react-icons/lu";
import "./CorporateGovernanceReport.style.css";

const CorporateGovernanceReport = () => {
  const { t } = useTranslation();
  const { lang } = useParams();
  const L = i18next.language?.startsWith("tr") ? "tr" : "en";

  const report = {
    name: {
      tr: "2025 Kurumsal Yönetim Raporu",
      en: "2025 Corporate Governance Report",
    },
    href: {
      tr: "/static/docs/cgr-2025-tr.pdf",
      en: "/static/docs/cgr-2025-en.pdf",
    },
  };

  return (
    <div>
      <Meta
        title={t("corporate-governance-report")}
        description={t("corporate-governance-report")}
        lang={lang}
      />
      <Navbar />

      <div className="c-wrapper">
        {/* Hero – mevcut görseli kullanıyoruz */}
        <div className="c-hero">
          <div className="c-hero-background">
            <picture>
              <img
                className="c-hero-image"
                alt=""
                src={require("../../assets/hero/public-offering.jpg")}
                style={{ width: "100%" }}
              />
            </picture>
          </div>
          <div className="c-hero-body">
            <div className="c-about-caption">
              <div className="c-caption-section" style={{ color: "#000", textAlign: "center" }}>
                {t("investor-relations")}
              </div>
              <h1 className="c-caption-header" style={{ color: "#000" }}>
                {t("corporate-governance-report")}
              </h1>
            </div>
          </div>
        </div>

        {/* İçerik */}
        <div className="po-container">
          <InvestorSidebar />

          <main className="cgr-content">
            <section className="cgr-card">
              <ul className="cgr-list">
                <li className="cgr-row">
                  <span className="cgr-title">{report.name[L] || report.name.en}</span>
                  <a
                    href={report.href[L] || report.href.en}
                    target="_blank"
                    rel="noreferrer"
                    className="cgr-dl"
                    aria-label={(t("download") || "İndir") + ": " + (report.name[L] || report.name.en)}
                  >
                    <LuDownload size={18} />
                  </a>
                </li>
              </ul>
            </section>
          </main>
        </div>
      </div>
    </div>
  );
};

export default CorporateGovernanceReport;
